import { UseQueryResult } from '@tanstack/react-query'
import { Stack, Title } from '@mantine/core'
import { PageContainer } from '@shared/components/app-shell/page-container/page-container'
import { PAGE_TITLES } from '@/constants/page-titles'
import { useAuthenticatedGraphQuery } from '@/hooks/use-authenticated-query'
import { DocumentsTable } from '@/components/shared/documents-table/documents-table'
import { GrowerServiceQuery } from '@shared/grower-api/.generated/types'
import { ListResourcesGql } from '@/graphql/queries/resources/list-resources.graphql'

export function ResourcesPage() {
  const { data, isError, isLoading }: UseQueryResult<GrowerServiceQuery> =
    useAuthenticatedGraphQuery({
      queryKey: ['listResources'],
      gql: ListResourcesGql,
    })

  return (
    <PageContainer title={PAGE_TITLES.RESOURCES}>
      <Stack>
        <Title>Resources</Title>
        <DocumentsTable data={data?.allDocuments ?? []} isError={isError} isLoading={isLoading} />
      </Stack>
    </PageContainer>
  )
}
